import React, { useEffect } from "react";
import { motion } from "framer-motion";

const SPLASH_TOTAL_MS = 1900;

const ROLL_TRANSITION = {
  delay: 0.1,
  duration: 1,
  times: [0, 0.85, 1],
  ease: [0.3, 0.8, 0.35, 1],
};

// Paths from icons/new-logo.svg (the MainAppBar logo), split so the S can
// roll into its exact place in the wordmark.
const S_PATH =
  "M9.34082 39.0146C12.1665 39.0146 14.8626 38.4335 16.8311 37.1123C18.7632 35.8154 20.0459 33.7747 20.0459 30.6885C20.0458 28.3961 19.2756 26.8562 18.1484 25.7373C16.9969 24.5944 15.4329 23.8508 13.7832 23.251C12.9604 22.9518 12.1398 22.6961 11.3457 22.4395C10.5616 22.186 9.79933 21.9303 9.13672 21.6396C7.86328 21.081 6.6436 20.2554 6.64355 18.7373C6.64355 17.5342 7.45475 16.7995 8.29297 16.4014C9.12557 16.006 10.1155 15.8652 10.8496 15.8652C11.7258 15.8652 12.5532 15.992 13.3232 16.249L13.7715 16.3984L13.7783 16.8711L13.8271 20.1016H18.4209V12.8389C16.1384 11.8157 13.5529 11.4561 11.0234 11.4561C8.53435 11.4561 5.9135 12.0596 3.9375 13.3359C1.98647 14.5963 0.667108 16.5031 0.666992 19.2012C0.666992 21.4861 1.46351 23.0483 2.6416 24.2002C3.84407 25.3759 5.47645 26.1564 7.19141 26.7852C8.04589 27.0984 8.90048 27.3669 9.72266 27.6318C10.5358 27.8938 11.3244 28.1539 12.0078 28.4424C12.6851 28.7283 13.3153 29.065 13.7822 29.5029C14.2677 29.9584 14.5907 30.54 14.5908 31.2686C14.5908 31.9717 14.3292 32.5418 13.9033 32.9727C13.4943 33.3863 12.96 33.647 12.4326 33.8174C11.3832 34.1563 10.1607 34.1982 9.39844 34.1982C6.4517 34.1981 3.27305 33.0356 0.724609 31.4658V37.2412C3.35591 38.5442 6.35026 39.0146 9.34082 39.0146Z";

const REST_PATHS = [
  {
    d: "M70.2998 38.9568C72.9933 38.9567 75.6833 37.9669 77.3838 35.8943L78.5664 34.4529V38.2029H84.3115V12.2097H74.6211V17.0261H77.8701V24.3064C77.8701 26.4762 77.8854 28.8757 76.6133 30.9763C75.5178 32.8978 73.7437 34.024 71.5176 34.0242C69.9647 34.0242 68.7821 33.4976 68.0078 32.5251C67.2547 31.5792 66.9639 30.3057 66.9639 28.948V12.2097H57.042V17.0261H60.4648V29.0642C60.4648 32.3408 61.3593 34.7901 62.9766 36.4207C64.593 38.0502 67.0265 38.9568 70.2998 38.9568Z",
    stroked: true,
  },
  {
    d: "M99.5371 38.8406C100.539 38.8406 101.505 38.7963 102.236 38.6443V33.7937C101.614 33.929 101 34.0241 100.292 34.0242C99.3324 34.0242 98.3042 33.8567 97.4941 33.3494C96.6397 32.8141 96.0859 31.9334 96.0859 30.6882C96.086 29.7371 96.519 28.9856 97.1396 28.4119C97.7453 27.8521 98.545 27.4435 99.3545 27.1296C100.17 26.8133 101.045 26.575 101.829 26.3787C102.635 26.1768 103.31 26.0276 103.811 25.8748L104.672 25.6121V30.6882C104.672 33.197 105.299 35.1966 106.487 36.5603C107.663 37.9093 109.464 38.7253 112.011 38.7253C112.595 38.7253 113.166 38.6882 113.729 38.5896L114.899 33.906C114.781 33.9084 114.669 33.9089 114.564 33.9089C113.397 33.9089 112.483 33.6234 111.917 32.8542C111.393 32.1425 111.287 31.1592 111.287 30.1091V21.115C111.287 18.9282 111.268 16.8784 110.179 15.2175C108.232 12.2718 104.318 11.4559 100.756 11.4558C97.8684 11.4558 95.0748 12.0154 92.3711 12.9949V18.2185C94.9366 17.0775 97.7207 16.2136 100.582 16.2136C101.252 16.2136 102.298 16.2876 103.202 16.616C104.094 16.9401 105.078 17.615 105.078 18.9109C105.078 20.2516 104.151 21.0225 103.185 21.4734C102.231 21.9186 101.039 22.1514 100.145 22.3474L100.137 22.3494L99.1289 22.5632C96.7744 23.0785 94.4187 23.7279 92.5752 24.8542C90.5185 26.1109 89.123 27.9428 89.123 30.9207C89.1231 33.9162 90.3728 35.852 92.249 37.0701C94.1658 38.3143 96.7909 38.8405 99.5371 38.8406Z",
    stroked: true,
  },
  {
    d: "M127.529 38.2024V23.6106C127.529 21.9217 127.747 20.2341 128.539 18.9221C129.363 17.5569 130.752 16.6903 132.855 16.5627L133.562 16.5198V20.217H138.379V12.0686C137.039 11.7648 135.684 11.6292 134.229 11.6292C131.629 11.6292 129.207 12.4578 127.752 14.4836L126.543 16.1672V12.2092H117.607V17.0266H121.03V38.2024H127.529Z",
    stroked: true,
  },
  {
    d: "M156.563 39.0146C159.828 39.0146 162.749 38.5463 165.702 37.2734V32.1553C162.96 33.3985 160.142 34.0244 157.086 34.0244C154.858 34.0244 152.788 33.4451 151.216 32.2236C149.629 30.9913 148.603 29.1455 148.415 26.7373L148.359 26.0195H167.128C167.152 25.3798 167.153 24.7344 167.153 24.0742C167.153 20.2161 165.911 17.0573 163.768 14.8662C161.626 12.6767 158.528 11.3975 154.707 11.3975C146.96 11.3976 141.334 17.0668 141.334 24.9453C141.334 29.4342 143.028 32.9314 145.748 35.3145C148.478 37.7064 152.287 39.0146 156.563 39.0146ZM149.013 21.0703C149.72 18.2419 152.117 16.2715 154.939 16.2715C157.798 16.2715 159.954 18.3435 160.469 21.1104L160.615 21.8984H148.807L149.013 21.0703Z",
    stroked: true,
  },
  {
    d: "M200.42 38.8694H195.141V21.6973C195.141 19.3189 194.213 15.954 189.804 15.954C187.425 15.954 185.221 17.23 183.944 19.3189C182.726 21.3493 182.494 23.3218 182.494 26.6284V38.8694H177.157V4.52521H173.502V4.19617e-05H182.494V15.0254C184.118 12.7633 187.019 11.313 190.326 11.313C193.285 11.313 195.721 12.1832 197.578 13.9235C199.434 15.6639 200.42 18.2166 200.42 21.4651V38.8694Z",
    stroked: false,
  },
  {
    d: "M231.689 38.8694H226.874V35.6203C224.901 38.2887 221.652 39.6816 218.52 39.6816C212.196 39.6816 208.31 35.7945 208.31 29.471V16.6499H204.597V12.1252H213.588V29.3552C213.588 32.836 215.329 35.098 218.983 35.098C221.537 35.098 223.683 33.8804 225.017 31.6757C226.409 29.4131 226.468 26.9763 226.468 24.4237V16.6499H222.754V12.1252H231.689V38.8694Z",
    stroked: false,
  },
  {
    d: "M260.405 34.9827C256.576 38.9277 252.051 39.7395 246.772 39.7395C243.928 39.7395 241.028 39.2178 238.418 38.4634V4.46724H234.763V0.000484467H243.755V34.6926C245.031 34.9827 246.307 35.0985 247.642 35.0985C254.43 35.0985 258.896 31.9662 258.896 24.7142C258.896 18.8545 255.358 15.7802 249.672 15.7802C248.686 15.7802 247.7 15.896 246.772 16.1281V11.7193C248.106 11.4292 249.383 11.3129 250.717 11.3129C258.722 11.3129 264.292 16.5345 264.292 24.6563C264.292 28.485 263.131 32.1979 260.405 34.9827Z",
    stroked: false,
  },
  {
    d: "M47.7812 39.0129L42.6895 32.6643H31.6045V18.5745H45.6982V31.5315L51.6992 39.0129H52.1172V12.1545H25.2559V39.0129H47.7812Z",
    stroked: true,
  },
  {
    d: "M50.5479 42.4658L48.6484 40.0967L42.4883 32.415L40.9658 30.5186H34.918L35.7705 31.5801L41.9326 39.2627L44.5 42.4658H50.5479Z",
    stroked: true,
  },
];

const svgLayerStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
};

const OnboardingSplash = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(onFinish, SPLASH_TOTAL_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <motion.div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1400,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#FFFFFF",
      }}
      initial={{ clipPath: "circle(135% at 50% 46%)" }}
      animate={{ clipPath: "circle(0% at 50% 46%)" }}
      transition={{ delay: 1.35, duration: 0.5, ease: [0.7, 0, 0.4, 1] }}
    >
      <div
        style={{
          position: "relative",
          width: "min(62vw, 250px)",
          aspectRatio: "265 / 44",
        }}
      >
        <motion.svg
          viewBox="0 0 265 44"
          fill="none"
          style={{ ...svgLayerStyle, transformOrigin: "3.9% 57%" }}
          initial={{ opacity: 0, x: "-75vw", rotate: -390 }}
          animate={{ x: ["-75vw", "1vw", "0vw"], rotate: [-390, 10, 0], opacity: [0, 1, 1] }}
          transition={{
            x: ROLL_TRANSITION,
            rotate: ROLL_TRANSITION,
            opacity: { ...ROLL_TRANSITION, times: [0, 0.12, 1], ease: "linear" },
          }}
        >
          <path d={S_PATH} fill="#023331" stroke="#023331" strokeWidth="1.33333" />
        </motion.svg>
        <motion.svg
          viewBox="0 0 265 44"
          fill="none"
          style={svgLayerStyle}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.05, duration: 0.4, ease: [0.2, 0.8, 0.3, 1] }}
        >
          {REST_PATHS.map((path, index) => (
            <path
              key={index}
              d={path.d}
              fill="#023331"
              stroke={path.stroked ? "#023331" : undefined}
              strokeWidth={path.stroked ? "1.33333" : undefined}
            />
          ))}
        </motion.svg>
      </div>
    </motion.div>
  );
};

export default OnboardingSplash;
